export const GET_ALL_CONFIGS = 'selfPromotion/GET_ALL_CONFIGS';
export const SET_ALL_CONFIGS = 'selfPromotion/SET_ALL_CONFIGS';
export const SET_CONFIG = 'selfPromotion/SET_CONFIG';
export const SET_LOADING = 'selfPromotion/SET_LOADING';
export const GET_ALL_CYCLES = 'selfPromotion/GET_ALL_CYCLES';
export const SET_ALL_CYCLES = 'selfPromotion/SET_ALL_CYCLES';
